import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useMeter} from "../hooks/useMeter.ts";
import {
    Meter,
    MeterAggregation,
    MeterGrain,
    MeterPurpose,
    MeterResetPolicy,
    MeterStatus
} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useMeter();

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                meterCode: '',
                aggregation: MeterAggregation.COUNT,
                grain: MeterGrain.HOUR,
                unit: '',
                resetPolicy: MeterResetPolicy.NEVER,
                purpose: MeterPurpose.BILLABLE,
                latenessWindowMinutes: 1440,
                watermarkDelayMinutes: 15,
                status: MeterStatus.DRAFT,
                dimensions: [],
            } as Meter}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
